import { useEffect, useState } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { OrderDetailType } from '../../@types/order'
import { getGuestOrderDetail, getOrderDetail } from '../../api/orderHistory'
import { getMall, getProductDetail } from '../../api/product'
import { OrderDetailListItem } from '../../components/order/OrderDetailState'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { plusComma } from '../../js/script'

// 이미지 경로
const imgURL = '/images'

export default function OrderRefundComplete() {
  const [orderItem, setOrderItem] = useState<OrderDetailType>()
  const [claim, setClaim] = useState<any>([])
  const [claimText, setClaimText] = useState<string>('')
  const [allClaim, setAllClaim] = useState<any>()
  const { isAppView } = useAppContext()
  const { setIsLottie, hasAccessToken } = useCommonContext()

  const location = useLocation()

  useEffect(() => {
    if (!hasAccessToken) {
      // @ts-ignore
      getGuestOrderDetail(location.state?.orderNo, location.state?.guestToken)
        .then((res) => {
          setOrderItem(res.data)
          setIsLottie(false)
          setClaim(res.data.claimHistories[0])

          const array: any = []
          const optionArray: any = []

          const orderOptions = res.data.orderOptionsGroupByPartner[0].orderOptionsGroupByDelivery[0].orderOptions

          // 모든 API 요청을 병렬로 처리하기 위해 Promise 배열 생성
          const promises = orderOptions.map((el: any) => {
            array.push(el.orderOptionNo)

            return getProductDetail(el.productNo).then((respon) => {
              const category = respon.data.categories[0].categories
              const obj = {
                item_id: String(el?.productNo),
                item_name: el?.productName,
                affiliation: '어바웃피싱',
                item_list_price: el.price?.salePrice,
                item_selling_price: el.price?.salePrice - el.price?.immediateDiscountAmt,
                price: el.price?.salePrice - el.price?.immediateDiscountAmt,
                item_total_discount: el.price?.immediateDiscountAmt,
                discount: 0,
                coupon: '',
                index: 0,
                item_brand: respon.data.brand?.name,
                quantity: el.orderCnt,
                item_category: category[0]?.label,
                item_category2: category[1]?.label,
                item_category3: category[2]?.label,
                item_variant: el.optionTitle,
                item_list_id: '',
                item_list_name: '',
              }

              optionArray.push(obj) // 처리된 데이터를 배열에 추가
            })
          })

          // 모든 API 요청이 완료된 후에 TagManager 실행
          Promise.all(promises).then(() => {
            const updatedArray = optionArray.map((objItem: any) => {
              // coupon 배열에서 현재 objItem의 item_id와 같은 productNo를 가진 객체 찾기
              const matchingCoupon = res.data?.extraData?.productCoupon?.find(
                (couponItem: any) => couponItem.productNo === objItem.item_id
              )
              // 일치하는 coupon 객체가 있으면 coupon과 discount 필드 업데이트
              if (matchingCoupon) {
                return {
                  ...objItem,
                  coupon: matchingCoupon.text,
                  discount: matchingCoupon.price,
                }
              }
              // 일치하는 coupon이 없으면 원래 objItem 반환
              return objItem
            })
            const viewItem: DataLayerArgs = {
              dataLayer: {
                event: 'refund',
                ecommerce: {
                  currency: 'KRW',
                  transaction_id: String(orderOptions[0]?.orderNo), // 첫번째 orderOption의 orderNo를 사용 (필요에 따라 수정 가능)
                  shipping: res.data.firstOrderAmount?.deliveryAmt,
                  payment_type:
                    res.data.payType === 'NAVER_EASY_PAY'
                      ? '네이버페이'
                      : res.data.payType === 'KAKAO_PAY'
                      ? '카카오페이'
                      : res.data.payType === 'MY_PAY'
                      ? '어바웃피싱 페이'
                      : '신용 / 체크카드',
                  coupon: res.data.extraData.cartCoupon,
                  value: res.data.firstOrderAmount?.payAmt - res.data.firstOrderAmount?.deliveryAmt,
                  items: updatedArray,
                  pay_back: res.data.accumulationAmtWhenBuyConfirm,
                  reserve_discount: res.data.firstOrderAmount?.subPayAmt,
                },
              },
            }
            if (isAppView) {
              sendSetAppsflyerEvent({
                eventName: 'refund',
                eventType: {
                  currency: 'KRW',
                  transaction_id: String(orderOptions[0]?.orderNo), // 첫번째 orderOption의 orderNo를 사용 (필요에 따라 수정 가능)
                  shipping: res.data.firstOrderAmount?.deliveryAmt,
                  payment_type:
                    res.data.payType === 'NAVER_EASY_PAY'
                      ? '네이버페이'
                      : res.data.payType === 'KAKAO_PAY'
                      ? '카카오페이'
                      : res.data.payType === 'MY_PAY'
                      ? '어바웃피싱 페이'
                      : '신용 / 체크카드',
                  coupon: res.data.extraData.cartCoupon,
                  value: res.data.firstOrderAmount?.payAmt - res.data.firstOrderAmount?.deliveryAmt,
                  items: updatedArray,
                  pay_back: res.data.accumulationAmtWhenBuyConfirm,
                  reserve_discount: res.data.firstOrderAmount?.subPayAmt,
                },
              })
            } else {
              // TagManager를 한 번만 실행
              TagManager.dataLayer(viewItem)
            }
          })
        })
        .catch((err) => console.log(err))
    } else {
      // @ts-ignore
      getOrderDetail(location.state?.orderNo)
        .then((res) => {
          setOrderItem(res.data)
          setClaim(res.data.claimHistories[0])
          setIsLottie(false)
          const array: any = []
          const optionArray: any = []

          const orderOptions = res.data.orderOptionsGroupByPartner[0].orderOptionsGroupByDelivery[0].orderOptions

          // 모든 API 요청을 병렬로 처리하기 위해 Promise 배열 생성
          const promises = orderOptions.map((el: any) => {
            array.push(el.orderOptionNo)

            return getProductDetail(el.productNo).then((respon) => {
              const category = respon.data.categories[0].categories
              const obj = {
                item_id: String(el?.productNo),
                item_name: el?.productName,
                affiliation: '어바웃피싱',
                item_list_price: el.price?.salePrice,
                item_selling_price: el.price?.salePrice - el.price?.immediateDiscountAmt,
                price: el.price?.salePrice - el.price?.immediateDiscountAmt,
                item_total_discount: el.price?.immediateDiscountAmt,
                discount: 0,
                coupon: '',
                index: 0,
                item_brand: respon.data.brand?.name,
                quantity: el.orderCnt,
                item_category: category[0]?.label,
                item_category2: category[1]?.label,
                item_category3: category[2]?.label,
                item_variant: el.optionTitle,
                item_list_id: '',
                item_list_name: '',
              }

              optionArray.push(obj) // 처리된 데이터를 배열에 추가
            })
          })

          // 모든 API 요청이 완료된 후에 TagManager 실행
          Promise.all(promises).then(() => {
            const updatedArray = optionArray.map((objItem: any) => {
              // coupon 배열에서 현재 objItem의 item_id와 같은 productNo를 가진 객체 찾기
              const matchingCoupon = res.data?.extraData?.productCoupon?.find(
                (couponItem: any) => couponItem.productNo === objItem.item_id
              )
              // 일치하는 coupon 객체가 있으면 coupon과 discount 필드 업데이트
              if (matchingCoupon) {
                return {
                  ...objItem,
                  coupon: matchingCoupon.text,
                  discount: matchingCoupon.price,
                }
              }
              // 일치하는 coupon이 없으면 원래 objItem 반환
              return objItem
            })
            const viewItem: DataLayerArgs = {
              dataLayer: {
                event: 'refund',
                ecommerce: {
                  currency: 'KRW',
                  transaction_id: String(orderOptions[0]?.orderNo), // 첫번째 orderOption의 orderNo를 사용 (필요에 따라 수정 가능)
                  shipping: res.data.firstOrderAmount?.deliveryAmt,
                  payment_type:
                    res.data.payType === 'NAVER_EASY_PAY'
                      ? '네이버페이'
                      : res.data.payType === 'KAKAO_PAY'
                      ? '카카오페이'
                      : res.data.payType === 'MY_PAY'
                      ? '어바웃피싱 페이'
                      : '신용 / 체크카드',
                  coupon: res.data.extraData.cartCoupon,
                  value: res.data.firstOrderAmount?.payAmt - res.data.firstOrderAmount?.deliveryAmt,
                  items: updatedArray,
                  pay_back: res.data.accumulationAmtWhenBuyConfirm,
                  reserve_discount: res.data.firstOrderAmount?.subPayAmt,
                },
              },
            }
            if (isAppView) {
              sendSetAppsflyerEvent({
                eventName: 'refund',
                eventType: {
                  currency: 'KRW',
                  transaction_id: String(orderOptions[0]?.orderNo), // 첫번째 orderOption의 orderNo를 사용 (필요에 따라 수정 가능)
                  shipping: res.data.firstOrderAmount?.deliveryAmt,
                  payment_type:
                    res.data.payType === 'NAVER_EASY_PAY'
                      ? '네이버페이'
                      : res.data.payType === 'KAKAO_PAY'
                      ? '카카오페이'
                      : res.data.payType === 'MY_PAY'
                      ? '어바웃피싱 페이'
                      : '신용 / 체크카드',
                  coupon: res.data.extraData.cartCoupon,
                  value: res.data.firstOrderAmount?.payAmt - res.data.firstOrderAmount?.deliveryAmt,
                  items: updatedArray,
                  pay_back: res.data.accumulationAmtWhenBuyConfirm,
                  reserve_discount: res.data.firstOrderAmount?.subPayAmt,
                },
              })
            } else {
              // TagManager를 한 번만 실행
              TagManager.dataLayer(viewItem)
            }
          })
        })
        .catch((err) => console.log(err))
    }
  }, [])

  useEffect(() => {
    getMall().then((res) => {
      setAllClaim(res.data.claimReasonType)
    })
  }, [])

  useEffect(() => {
    if (allClaim && claim) {
      const matchedClaim = allClaim.find((el: any) => el.value === claim.claimReasonType)
      if (matchedClaim) {
        setClaimText(matchedClaim.label) // 일치하는 값이 있을 경우에만 설정
      }
    }
  }, [allClaim, claim])

  return (
    <>
      <div className='main_wrap'>
        <div className='contents_wrap'>
          <PageTitle>환불 신청 완료</PageTitle>

          <div
            style={{
              textAlign: 'center',
              padding: '48px 0',
              borderBottom: '8px solid var(--colGray1)',
            }}
          >
            <img src={`${imgURL}/icon_complete.png`} style={{ width: '56px', margin: '0 auto 20px' }} alt='' />
            <p
              style={{
                fontSize: '16px',
                lineHeight: '24px',
                color: 'var(--colBlack)',
                fontWeight: '500',
              }}
            >
              환불 신청이 정상적으로 완료되었습니다. <br />
              이용해 주셔서 감사합니다.
            </p>
          </div>

          <OrderProduct>
            <div className='order_product_tit'>
              <div>
                <p>상품 정보</p>
                <em>주문번호 {orderItem?.orderNo}</em>
              </div>
              <span>{`${orderItem?.paymentExpirationYmdt?.split(' ', 1).join('').replaceAll('-', '.')} 결제완료`}</span>
            </div>
            {orderItem?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.map(
              (el: any, idx: number) => {
                return (
                  <OrderDetailListItem
                    el={el}
                    key={el.optionNo}
                    idx={idx}
                    lastNumber={
                      orderItem?.orderOptionsGroupByPartner[0]?.orderOptionsGroupByDelivery[0]?.orderOptions.length
                    }
                  ></OrderDetailListItem>
                )
              }
            )}
          </OrderProduct>

          <OrderInfoList>
            <p>환불 정보</p>
            <dl>
              <dt>주문번호</dt>
              <dd>{plusComma(orderItem?.firstOrderAmount?.standardAmt)}원</dd>
            </dl>
            <dl>
              <dt>환불수단</dt>
              <dd>{`${orderItem?.payInfo?.cardInfo?.cardName ? orderItem?.payInfo?.cardInfo?.cardName : ''} ${
                orderItem?.payInfo?.cardInfo?.cardNo ? orderItem?.payInfo?.cardInfo?.cardNo : ''
              }${
                orderItem?.pgType === 'NAVER_EASY_PAY'
                  ? '네이버페이'
                  : orderItem?.pgType === 'KAKAO_PAY'
                  ? '카카오페이'
                  : orderItem?.pgType === 'MY_PAY'
                  ? '마이페이'
                  : ''
              }`}</dd>
            </dl>
            <dl>
              <dt>반품 사유</dt>
              <dd>{claimText}</dd>
            </dl>
            <dl>
              <dt>상품 결제 금액</dt>
              <dd>{plusComma(orderItem?.payInfo?.payAmt)}원</dd>
            </dl>
            <dl>
              <dt>환불 금액</dt>
              <dd>{plusComma(orderItem?.refundInfos?.[0]?.productAmtInfo?.totalAmt)}원</dd>
            </dl>
            <dl className='save'>
              <dt>환불 적립금</dt>
              <dd>{plusComma(orderItem?.refundInfos?.[0]?.refundSubPayAmt)}원</dd>
            </dl>
            <dl>
              <dt>반품 배송비</dt>
              <dd>{plusComma(orderItem?.refundInfos?.[0]?.deliveryAmtInfo?.totalAmt)}원</dd>
            </dl>
            <dl className='result_pay'>
              <dt>예상 환불금액</dt>
              <dd>{plusComma(orderItem?.refundInfos?.[0]?.refundPayAmt)}원</dd>
            </dl>
          </OrderInfoList>
        </div>
      </div>
    </>
  )
}
export const OrderProduct = styled.p`
  padding: 24px 20px;
  border-top: 8px solid var(--colGray1);
  & .order_product_tit {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--colGray3);

    & div {
      & p {
        font-size: 16px;
        line-height: 24px;
        color: var(--colBlack);
        font-weight: 700;
      }
      & em {
        font-size: 14px;
        line-height: 18px;
        font-style: normal;
        margin-top: 4px;
      }
    }
    & span {
      font-size: 12px;
      line-height: 18px;
      color: var(--colGray6);
    }
  }

  & .order_item {
    & .g_color {
      & .img_box {
        position: relative;
        width: 80px;
        height: 80px;
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 10px;
        }
      }
      & p {
        color: var(--colGray5) !important;
      }
    }
  }

  & .order_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 24px;
    & button {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colBlack);
      text-align: center;
      padding: 11px 0;
      border: 1px solid var(--colGray3);
      border-radius: 5px;
      background: transparent;
    }
  }

  & .info_txt {
    margin: 16px 0 24px;
    & p {
      font-size: 12px;
      line-height: 18px;
      color: var(--colGray6);
    }
  }
`
export const OrderInfoList = styled.p`
  padding: 24px 20px;
  border-top: 8px solid var(--colGray1);
  & .btn_tit_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    & p {
      margin: 0;
    }
    & button {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      color: var(--colGray7);
      padding: 8px 10px;
      border: 1px solid var(--colGray3);
      border-radius: 38px;
      background: transparent;
    }
  }
  & p {
    font-size: 16px;
    line-height: 24px;
    color: var(--colBlack);
    margin-bottom: 16px;
    font-weight: 700;
  }
  & dl {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--colGray3);
    padding: 16px 0;
    & dt {
      font-size: 14px;
      line-height: 18px;
      color: var(--colBlack);
    }
    & dd {
      font-size: 14px;
      line-height: 18px;
      color: var(--colBlack);
    }
    &.save {
      & dt {
        padding-left: 18px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 2px;
          left: 0;
          background: url('../../images/icon_point.png') no-repeat;
          background-size: contain;
          width: 14px;
          height: 14px;
        }
      }
    }
    &.result_pay {
      & dt {
        font-weight: 700;
      }
      & dd {
        font-weight: 700;
      }
    }

    &.left_align {
      gap: 20px;
      justify-content: flex-start;
      & dt {
        min-width: 80px;
      }
      & dd {
        width: 100%;
      }
    }
  }
`
